import Plotly from 'plotly.js/lib/core';
import Scatter from 'plotly.js/lib/scatter';
import Scatter3d from 'plotly.js/lib/scatter3d';
import ScatterPolar from 'plotly.js/lib/scatterpolar';
import createPlotlyComponent from 'react-plotly.js/factory';

Plotly.register([Scatter, Scatter3d, ScatterPolar]);

const Plot = createPlotlyComponent(Plotly);
export default Plot;
